import I18n from 'i18n-js';

import { useTimer } from '@lootboy/lib/hooks';

import { getTimerLabel } from '~/utils';

import styles from './SurveyTimer.module.scss';

export function SurveyTimer({
  availableFrom,
  availableUntil,
  isAvailable,
  isExpired,
}: {
  availableFrom: string | undefined;
  availableUntil: string | undefined;
  isExpired: boolean;
  isAvailable: boolean;
}): JSX.Element {
  const startTimer = useTimer(availableFrom ?? 0);
  const endTimer = useTimer(availableUntil ?? 0);

  if (startTimer.ended && endTimer.ended) {
    return <></>;
  }

  return (
    <div className={styles.timer}>
      {!isAvailable && !startTimer.ended && (
        <>{`${I18n.t('SurveyView_countdown_label')}: ${getTimerLabel(
          startTimer,
        )}`}</>
      )}
      {isAvailable && !isExpired && !endTimer.ended && (
        <>{`${I18n.t('SurveyView_remaining_time_label')}: ${getTimerLabel(
          endTimer,
        )}`}</>
      )}
    </div>
  );
}
